export default __webpack_public_path__ + "static/media/trr-food-handheld-tunacroissant.2634ff7d.png";